import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";


const Main = lazy(() => import("../components/nomination/endorsement/main"));

const Endorsement = () => {
  return (

      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>

  );
};

export default Endorsement;
